import { createSelector } from 'reselect';

const getSectorEntities = (store) => store.entities.sectors;

const getSectorsById = createSelector([getSectorEntities], (sectorEntities) => {
    return sectorEntities.byId;
});

export default getSectorsById;
